var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85811 4.77982C6.83585 3.76951 6.11337 3 4.94018 3C3.76699 3 3 3.76951 3 4.77982C3 5.7692 3.74432 6.56086 4.89567 6.56086H4.91758C6.11337 6.56086 6.85811 5.7692 6.85811 4.77982ZM6.63203 7.96733H3.20258V18.2714H6.63203V7.96733ZM15.0512 7.72534C17.3079 7.72534 18.9998 9.19836 18.9998 12.3633L18.9996 18.2714H15.5703V12.7587C15.5703 11.374 15.074 10.4292 13.8326 10.4292C12.8851 10.4292 12.3208 11.0661 12.0729 11.6813C11.9822 11.9018 11.96 12.209 11.96 12.517V18.2716H8.53013C8.53013 18.2716 8.57533 8.93445 8.53013 7.96757H11.96V9.42705C12.4152 8.72545 13.2304 7.72534 15.0512 7.72534Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.46ebf59ac7a00182d56ad7892a835177.svg";
export { ForwardRef as ReactComponent };